import React from "react";
import "./C2Page.css";
import Testimonial from "../Testimonial/Testimonial";
const C2Flexibility = () => {
  return (
    <div className="c2FlexContainer">
      <h1>
        Master Your German with C2 <span>German Classes</span> in Bangalore at Prizma Academy
      </h1>
      <p>
        Are you ready to take your German language skills to the pinnacle of
        proficiency? Look no further! Prizma Academy offers C2 German classes in
        Bangalore designed to help you achieve mastery in the German language.
        Our comprehensive C2 German classes in Bangalore are tailored to meet
        the needs of advanced learners who aspire to reach the highest level of
        language competence.
        <Testimonial/>

      </p>
    </div>
  );
};

export default C2Flexibility;
